import React from 'react';
import PropTypes from 'prop-types';
import RBSweetAlert from 'react-bootstrap-sweetalert';
import { useSweetAlert } from './hooks/useSweetAlert';
import {
  getAlertTypeProps,
  getDefaultConfirmStyle,
} from './utils/sweetAlertHelpers';

const SweetAlert = ({
  variant,
  title,
  children,
  onConfirm,
  onCancel,
  showCancel,
  confirmBtnText,
  cancelBtnText,
  confirmBtnBsStyle,
  cancelBtnBsStyle,
  ...props
}) => {
  const { handleConfirm, handleCancel } = useSweetAlert({ onConfirm, onCancel });
  const alertTypeProps = getAlertTypeProps(variant);
  const defaultConfirmStyle = getDefaultConfirmStyle(variant);

  return (
    <RBSweetAlert
      {...alertTypeProps}
      title={title}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      showCancel={showCancel}
      confirmBtnText={confirmBtnText}
      cancelBtnText={cancelBtnText}
      confirmBtnBsStyle={confirmBtnBsStyle || defaultConfirmStyle}
      cancelBtnBsStyle={cancelBtnBsStyle || 'secondary'}
      {...props}
    >
      {children}
    </RBSweetAlert>
  );
};

SweetAlert.propTypes = {
  variant: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'danger', 'default']),
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  confirmBtnBsStyle: PropTypes.string,
  cancelBtnBsStyle: PropTypes.string,
};

SweetAlert.defaultProps = {
  variant: 'success',
  children: null,
  onCancel: () => {},
  showCancel: false,
  confirmBtnText: 'OK',
  cancelBtnText: 'Cancelar',
  confirmBtnBsStyle: '',
  cancelBtnBsStyle: '',
};

export default SweetAlert;



// WEBPACK FOOTER //
// ./src/design-system/atoms/SweetAlert/SweetAlert.jsx